export const TestIds = {
  itemLabel: 'submenu-item-label',
  subItemLabel: 'submenu-sub-item-label',
  rootLevelListItem: 'submenu-root-level-list-item',
};
